import { dueTone as sharedDueTone } from './requestFilter';
import { formatDate } from './format';

/* Date helpers for the task detail page (moved from the removed ChangeAttributeRail). */

const DAY = 86_400_000;

/** Whole calendar-ish days from now to `iso` (negative once passed). */
export function daysLeft(iso: string, now = Date.now()): number {
  const ms = new Date(iso).getTime() - now;
  return ms >= 0 ? Math.floor(ms / DAY) : -Math.ceil(-ms / DAY);
}

/** "3 hours ago" / "2 days ago" / "just now". */
export function ago(iso: string, now = Date.now()): string {
  const s = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (s < 60) return 'just now';
  const m = Math.round(s / 60);
  if (m < 60) return `${m} minute${m === 1 ? '' : 's'} ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} hour${h === 1 ? '' : 's'} ago`;
  const d = Math.round(h / 24);
  if (d < 30) return `${d} day${d === 1 ? '' : 's'} ago`;
  return formatDate(iso);
}

/** Relative due phrase + tone, for chips. */
export function dueTone(iso: string, closed: boolean): { text: string; cls: string } {
  const d = daysLeft(iso);
  if (closed) return { text: '', cls: 'cr-due' };
  if (d < 0) return { text: `overdue ${-d}d`, cls: 'cr-due cr-due--over' };
  if (d === 0) return { text: 'due today', cls: 'cr-due cr-due--soon' };
  return {
    text: `in ${d} day${d === 1 ? '' : 's'}`,
    // Same 7×24h rule as the lists (lib/requestFilter.ts).
    cls: sharedDueTone(iso, Date.now()) === 'soon' ? 'cr-due cr-due--soon' : 'cr-due',
  };
}

/** `<input type="date">` value (local) for an ISO timestamp. */
export function toDateInput(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** A picked date means "by the end of that local day". */
export function fromDateInput(v: string): string | null {
  if (!v) return null;
  const d = new Date(`${v}T23:59:00`);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
